import React from 'react';
import { useTranslation } from 'react-i18next';
import cls from 'clsx';
import styles from './styles.module.css';

interface ConfirmProps {
  show: boolean;
  content: string;
  confirmText?: string;
  cancelText?: string;
  className?: string;
  onConfirm: () => void;
  onClose?: () => void;
}

const Confirm: React.FC<ConfirmProps> = ({
  show,
  content,
  confirmText,
  cancelText,
  className,
  onConfirm,
  onClose
}) => {
  const { t } = useTranslation();

  if (!show) return null;

  return (
    <div className={cls(styles.overlay, className)}>
      <div className={styles.modal}>
        <div className={styles.content}>{content}</div>
        <div className={styles.buttonGroup}>
          {cancelText && onClose && (
            <button className={styles.cancelButton} onClick={onClose}>
              {cancelText || t('components.confirm.cancel')}
            </button>
          )}
          {confirmText && onConfirm && (
            <button className={styles.confirmButton} onClick={onConfirm}>
              {confirmText || t('components.confirm.confirm')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Confirm;
